import { Tag } from '@eventbrite/eds-tag';
import { gettext } from '@eventbrite/i18n';
import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import {
    DATES_TO_REFINEMENT,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    EVENTBRITE_FORMAT_TO_REFINEMENT,
} from '../../../../../../constants';
import { TagGroup } from './TagGroup';

interface FilterSuggestionsProps {
    suggestedFilters?: $FixMe;
    handleApplyFilterSimple: Function;
    trackGAEvent?: Function;
}

export const FilterSuggestions = (props: FilterSuggestionsProps) => {
    if (props.suggestedFilters.length < 4) {
        return null;
    }

    const handleTagClick = (filter: { type?: string; value: string }) => {
        window.scroll(0, 0);
        const labelValues: { [key: string]: object } = {
            EVENTBRITE_CATEGORY_TO_REFINEMENT,
            EVENTBRITE_FORMAT_TO_REFINEMENT,
            DATES_TO_REFINEMENT,
        };

        props.handleApplyFilterSimple({ [filter.type || '']: filter.value });
        props.trackGAEvent?.({
            action: 'QuickFilter',
            label: labelValues[filter.value] || 'free',
        });
    };

    return (
        <TagGroup
            containerClassName="pivot-section suggested-filters"
            suggestedItems={props.suggestedFilters}
            headerText={gettext('Suggested filters')}
            render={(filter: { value: string; display: string }) => {
                return (
                    <div className="eds-l-mar-all-1" key={filter.value}>
                        <Tag
                            style="outlined"
                            onActiveToggle={() => handleTagClick(filter)}
                        >
                            {filter.display}
                        </Tag>
                    </div>
                );
            }}
        />
    );
};
